var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('breadcrumb',{attrs:{"breadcrumbs":_vm.breadcrumbs}}),_vm._v(" "),_c('header-banner',{attrs:{"title":"お役立ちコラム"}}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.htmlContent)}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f59b4f5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Column.vue
// module id = null
// module chunks = 